import { AbstractControl, ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { TvaCustomService } from '../../tva-custom.service';

export function customTableViewNameValidatorOnNew(
  control: AbstractControl,
  translateService: TranslateService,
  tvaCustomService: TvaCustomService,
): ValidationErrors | null {
  const val = control.value;

  if (tvaCustomService.tableViewOptions && tvaCustomService.tableViewOptions.length > 0 && val !== null) {
    // Not allowed if the new name is the same as the SystemDefault name.
    if (val.trim() === translateService.instant('TABLE_VIEW_SYSTEM_DEFAULT')) {
      return { nameNotAllowed: true };
    }
    if (
      tvaCustomService.tableViewOptions.some(
        tableViewCustomModelOption => val.trim() === tableViewCustomModelOption.tableViewName.trim(),
      )
    ) {
      return { nameExist: true };
    }
  }
  return null;
}

export function customTableViewNameValidatorOnEdit(
  control: AbstractControl,
  translateService: TranslateService,
  tvaCustomService: TvaCustomService,
): ValidationErrors | null {
  const val = control.value;
  const selectedTableView = tvaCustomService.getSelectedTableView();

  if (tvaCustomService.tableViewOptions && tvaCustomService.tableViewOptions.length > 0 && val !== null) {
    const matchedTableViewByName = tvaCustomService.tableViewOptions.find(
      tableViewCustomModelOption => tableViewCustomModelOption.tableViewName === val,
    );

    // Not allowed if the new name is the same as the SystemDefault name.
    if (val.trim() === translateService.instant('TABLE_VIEW_SYSTEM_DEFAULT')) {
      return { nameNotAllowed: true };
    }
    // Value which get edited can of course stay on his previous name.
    if (matchedTableViewByName && matchedTableViewByName.id !== selectedTableView.id) {
      return { nameExist: true };
    }
  }
  return null;
}
